/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const types = [
  { label: 'BOOLEAN', description: null },
  { label: 'INT', description: null },
  { label: 'TINYINT', description: null },
  { label: 'SMALLINT', description: null },
  { label: 'BIGINT', description: null },
  { label: 'DECIMAL', description: null },
  { label: 'DOUBLE', description: null },
  { label: 'REAL', description: null },
  { label: 'TIME', description: null },
  { label: 'DATE', description: null },
  { label: 'TIMESTAMP', description: null },
  { label: 'VARCHAR', description: null },
  { label: 'CHAR', description: null },
  { label: 'UUID', description: null },
  { label: 'BINARY', description: null },
  { label: 'GEOMETRY', description: null },
];
